/** Remove obsolete password caches; authentication is owned by HttpOnly cookies. */
export function clearCredentials(): void {
  localStorage.removeItem('locs-user-credentials');
  localStorage.removeItem('locs_user_credentials');
}
